import icon_china_flag from '@/assets/icons/icon_china_flag.svg';

export const USER_INFO_STORAGE_KEY = 'userInfo'; // 用户信息持久化存储键名



// 定义左侧菜单项
export const manageMenuItems = [
    {
        key: 'overview',
        label: '总览',
    },
    {
        key: 'billing',
        label: '积分流水',
    },
    // {
    //     key: 'management',
    //     label: '套餐管理',
    // },
    {
        key: 'account',
        label: '账户信息',
    },
    // {
    //     key: 'invoice',
    //     label: '账单发票',
    // },
    {
        key: 'invitation-rewards',
        label: '邀请奖励',
    },
];

// 世界重建（工作台）左侧菜单项
export const reconstructionMenuItems = [
    {
        key: 'my-reconstruction',
        label: '我的重建',
    },
    {
        key: 'rebuild-creation',
        label: '重建创建',
    },
];

// 语言配置数组
export const languageOptions = [
    { key: 'zh', text: '中文', iconSrc: icon_china_flag },
    // { key: 'en', text: '英文', iconSrc: icon.icon_usa_flag },
];


export const ReconstructingStatusEnum = {
    QUEUE: 'queued',          // 排队中
    PROCESSING: 'processing', // 生成中
    SUCCEEDED: 'succeeded',   // 成功
    FAILED: 'failed',         // 失败
    CANCELED: 'canceled',     // 已取消
}

// 错误消息
export const ERROR_MESSAGES = {
  EMPTY_ACCOUNT: "账号不能为空",
  EMPTY_PASSWORD: "密码不能为空",
  NETWORK_ERROR: "网络问题，稍后再试",
  INVALID_PHONE: "请输入有效的手机号"
};

/**
 * 业务错误码 → 中文提示文案
 * 值来源于《Web云端高斯任务API文档·四、错误码》表（含通用与高斯任务专用）。
 * 在 request 底层将英文 errorMsg 替换为这里的友好文案。
 */
export const ERROR_CODE_MESSAGES = {
    // 4.1 通用
    20001: '参数非法（文件名含路径穿越字符、图片后缀不在白名单等）',
    20002: '缺少必填参数',
    20004: '签名校验失败',
    20012: '请求方法不受支持（非 GET/POST/DELETE）',
    20102: '登录用户不存在',
    20600: '服务内部异常',
    // 4.2 高斯任务专用
    40001: '该区域未配置对象存储/CDN（海外暂未开通）',
    40002: '任务队列已满，请稍后重试',
    40003: '任务不存在或已被删除',
    40004: '上传前缀下没有文件',
    40005: '下载的 key 不属于该任务产物',
    40006: '单次上传文件数超上限',
    40007: '非本人任务',
    40008: '该区域未配置 MQ',
    40009: 'MQ 不可达或投递失败',
    40010: '上传前缀与当前用户不匹配',
    40901: '任务正在运行中，无法删除',
};

// 流水类型
export const BillingTypeEunm = {
    DEDUCT: 3, // 扣费流水
    FREEZE: 2, // 冻结流水
    RELEASE: 4, // 返还流水
    RECHARGE: 1, // 充值流水
    EXPIRE: 5, // 过期流水
    GIFT: 0, // 赠送流水
    REFUND: 6, // 退款流水  
}

export const BusinessTypeEnum = {
    SC: "sc", // 空间计算
    SC_EXPORT: "sc_export", // 空间计算数据导出
    FORMAT_CONVERT: "format_convert", // 格式转换
    DSM_DOM: "dsm_dom", // DSM / DOM
    DENSE_POINTCLOUD: "dense_pointcloud", // 稠密点云
    MESH: "mesh", // MESH（OBJ / OSGB）
    GS_SELF: "3dgs_self", // 3DGS（自有）
    GS_GAODE: "3dgs_gaode", // 3DGS（高德云镜高斯）
    GS_THIRD: "3dgs_third", // 3DGS（第三方）
    TEXT_TO_MODEL: "text-to-model", // 文生材质模型
    TEXT_TO_MESH: "text-to-mesh", // 文生网格模型
    IMAGE_TO_MODEL: "image-to-model", // 图生材质模型
    IMAGE_TO_MESH: "image-to-mesh", // 图生网格模型
};
// 业务类型 → 中文描述
export const BusinessTypeMap = {
    "sc": "空间计算",
    "sc_export": "空间计算数据导出",
    "format_convert": "格式转换",
    "dsm_dom": "DSM / DOM",
    "dense_pointcloud": "稠密点云",
    "mesh": "MESH（OBJ / OSGB）",
    "3dgs_self": "3DGS（自有）",
    "3dgs_gaode": "3DGS（高德云镜高斯）",
    "3dgs_third": "3DGS（第三方）",
    "text-to-model": "文生材质模型",
    "text-to-mesh": "文生网格模型",
    "image-to-model": "图生材质模型",
    "image-to-mesh": "图生网格模型",
};

// 用户套餐类型
export const LevelEnum = {  
    FREE: 0, // 体验版
    PRO: 1, // 专业版
}

// 产品 spu（商品品类）
export const SpuEnum = {
    FREE: 1,      // 免费版
    PRO: 2,       // 专业版
    ENTERPRISE: 3,// 企业版
    EXTRA: 4,     // 加量包
}

// 产品 sku（按年 / 按月 / 按日）
export const SkuEnum = {
    YEAR: 1,      // 年付
    MONTH: 2,     // 月付
    DAY: 3,       // 日付
}

// 订单状态
export const OrderStatusEnum = {
    PENDING: 1, // 待支付
    PROCESS: 2, // 处理中
    SUCCESS: 3, // 已完成
    CANCELED: 4, // 已取消
}

// 订单发票状态
export const InvoiceStatusEnum = {
    NOT: 0, // 未开票
    PROCESS: 1, // 开票中
    SUCCESS: 2, // 已开票
}

// 发票类型（值直接对应 API 的 invoice_type）
export const InvoiceTypeEnum = {
    ELECTRONIC: 1, // 电子普通发票
    SPECIAL: 2,    // 增值税专用发票
};

// 抬头类型（值直接对应 API 的 title_type）
export const TitleTypeEnum = {
    PERSONAL: 1, // 个人/非企业单位
    COMPANY: 2,  // 企业/事业单位
};

/** 世界模型区块统一横向留白（与 LargeSpatialBuild 大图容器一致） */
export const WORLD_MODEL_SECTION_PX =
    'px-6 md:px-12 lg:px-20 xl:px-32 2xl:px-60';

/** 世界模型区块统一内容最大宽度（与 LargeSpatialBuild 大图一致） */
export const WORLD_MODEL_CONTENT_WIDTH =
    'w-full max-w-[56.25rem] lg:max-w-[70rem] xl:max-w-[80rem] 2xl:max-w-[90rem]';

/** 居中内容通道：左右边界与大图对齐 */
export const WORLD_MODEL_CONTENT_LANE = `mx-auto ${WORLD_MODEL_CONTENT_WIDTH}`;

/** 固定 Header 高度，滚动锚点需减去该值 */
export const HEADER_HEIGHT = 100;



// Map引擎枚举

export const WordNodeName = "OSG_World_Root";  // 坐标轴转换根节点，代替scene
export const GizmoWorldNodeName = 'gizmo-world-root'; // 左下角小坐标系根节点
export const GeomPosition = 'position';
export const GeomColor = 'color';
export const GeomPointId = 'pointId';
export const GeomHighlight = 'aHighlight';   // 点云高亮属性名
export const GeomPickColor = 'aPickColor';   // 点云 GPU 拾取编码颜色属性名
export const InstancedGroupName = 'instanced-group'; // instanced外层组名字

// 鼠标行为枚举
export const MouseBehaviorEnum = {
    DOWN: 'down', // 鼠标按下
    UP: 'up', // 鼠标抬起
    MOVE: 'move', // 鼠标移动
}

// 选项工具枚举
export const OptionToolsMnum = {
    SELECT: 'select',  // 选择
    TRANSLATE: 'translate',  // 平移
    ROTATE: 'rotate',   // 旋转
    SCALE: 'scale',   // 缩放
};


// 场景组类型枚举
export const SceneGroupTypeMnum = {
    CONTAINER: 'container', // Group 容器，可挂载子场景组
    GROUP: 'group',         // 普通场景组
};

// 加载遮罩 文本状态枚举
export const LoadingTextColorEnum = {
    WHITE: 'white',
    PRIMARY: 'primary',
    WARNING: 'warning',
    ERROR: 'error'
};


// 引擎交互模式
export const MapModelEnum = {
    NONE: 'none', // 正常交互模式
    RECT: 'rect', // 矩形选区模式 
    POLYGON: 'polygon', // 多边形选区模式  
    BBOX: 'bbox', // 包围盒拖动模式
    MODLEOPT: 'modelOpt', // 模型操作模式
}

// 多边形选区模式的目标
export const SelectionTargetEnum = {
    CLOUD: 'cloud', // 点云
    TILE: 'tile', // 瓦片
}

// 鼠标操作类型枚举
export const MouseOptionEnum = {
    onLeftClick: 'onLeftClick',   // 左键点击
    onRightClick: 'onRightClick', // 右键点击
    onMouseMove: 'onMouseMove',  // 鼠标移动
    onMouseUp: 'onMouseUp',      // 鼠标抬起
    onMouseDown: 'onMouseDown',  // 鼠标按下
}

// ROI类型枚举
export const ROITypeEnum = {
    BOX: 0, // 包围盒
    POLYGON: 1, // 多边形
}


// 场景图层枚举
export const LayerTypeEnum = {
    IMAGE:"photos",  // 图片
    POINTS:"points", // 连接点
    GCPS:"gcps",  // 控制点
    TILES:"tiles",  // 分块
    INTERESTAREA:"interestArea",//兴趣区
}


// "Mesh_Obj" | "PointCloud_Ply" | "Triverse" | "Sam3D" | "Gs3DTiles" | "Gs3DGlb"
export const SceneTypeEnum = {
    MESH_OBJ: "Mesh_Obj",
    POINT_CLOUD_PLY: "PointCloud_Ply",
    TRIVERSE: "Triverse",
    SAM3D: "Sam3D",
    GS3DTILES: "Gs3DTiles",
    GS3DGLB: "Gs3DGlb", // 高斯泼溅单文件 GLB 场景（KHR_gaussian_splatting / spz_2 压缩）
}